export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/entities.worker.6f0e2b77.worker.js");
}
